export default function AppPageShell({
  title,
  subtitle,
  children,
  headerExtra,
  className = "",
}) {
  return (
    <div className={`app-page${className ? ` ${className}` : ""}`}>
      <div className="app-page__header">
        <h1 className="app-page__title">{title}</h1>

        {subtitle && <p className="app-page__subtitle">{subtitle}</p>}

        {headerExtra && (
          <div className="app-page__header-extra">{headerExtra}</div>
        )}
      </div>

      {children}
    </div>
  );
}
